module.exports = __webpack_public_path__ + "img/forwardarw.5b98b485.svg";